<template>
  <div class="row">
    <div class="col-md-12">
      <div class="mb-3">
        <label for="type" class="col-form-label">Type</label>
        <select class="form-select" id="type" v-model="form.type">
          <option value="">Select once</option>
          <option value="card">Card</option>
          <option value="bank">Bank</option>
        </select>
        <v-errors :errors="errorFor('type')"></v-errors>
      </div>

      <InputGroup
          label="Name"
          type="text"
          v-model="form.name"
          placeholder="name"
          :required="true"
          :validation-error="errorFor('name')"
      />
      <div class="row">
          <div class="col_6">
            <div :class="['form_row', {'has_error': errorFor('card.name')}]">
              <label class="required">Card Holder Name</label>
              <div class="form_input">
                <input type="text" class="form-control" placeholder="Name" v-model="form.card_name">
              </div>
            </div>
            <div :class="['form_row', {'has_error': errorFor('card.expire')}]">
              <label class="required">Expiration Date</label>
              <div class="form_inputx" id="card-expiry">
                <input type="text" class="form_global" placeholder="Expiration Date" v-model="form.card_expire_date">
              </div>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form_row', {'has_error': errorFor('card.number')}]">
              <label class="required">Card Number</label>
              <div class="form_inputx" id="card-number">
                <input type="text" class="form_global" placeholder="Number" v-model="form.card_number">
              </div>
            </div>
            <div :class="['form_row', {'has_error': errorFor('card.cvc')}]">
              <label class="required">Secure Code (CVV)</label>
              <div class="form_inputx" id="card-cvc">
                <input type="text" class="form_global" placeholder="Secure Code (CVV)" v-model="form.card_cvc">
              </div>
            </div>
          </div>
          <div class="col_12 mb_10">
            <div class="has_error">
              <small v-if="error" id="card-errors" class="invalid-feedback d-block text_danger" role="alert">{{ error }}</small>
            </div>
          </div>
          <div class="col_12">
            CVV2 is that extra set of numbers after the normal 16 or 14 digits of the account usually printed on the back of the credit card. The "CVV2 security code", as it is formally referred to, provides an extra measure of security and we require it on all transactions.
          </div>

          <div class="mb-3">
            <div class="form-check form-check-inline">
              <input type="checkbox" v-model="form.is_default" class="form-check-input" name="is_default" id="is_default" value="1">
              <label class="form-check-label" for="is_default">Default</label>
              <v-errors :errors="errorFor('agree')"></v-errors>
            </div>
          </div>

      </div>

      <div class="mb-3">
        <div class="d_flex_start">
          <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" @click="submit">Submit</button>
          <button class="btn btn-secondary ms-3" @click="closeModal()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import InputGroup from "@/components/FormControl/InputGroupComponent.vue";

export default {
  name: 'PaymentMethodForm',
  components: {InputGroup},
  props: ['closeModal', 'loadData', 'editId'],
  data() {
    return {
      lyLoading: false,
      minCardYear: new Date().getFullYear(),
      form: {
        type: '',
        is_default: false,
        card_number: '',
        card_expire_date: ''
      },
      stripePublicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      stripe: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      error: null
    }
  },
  computed:{
    getCardType () {
      let number = this.form.card_number;

      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return "visa"; // default type
    },
    minCardMonth () {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    },
  },
  watch: {
    cardYear () {
      if (this.cardMonth < this.minCardMonth) {
        this.cardMonth = "";
      }
    }
  },
  created() {
    if (this.editId) {
      this.getPaymentMethod()
    }
  },
  async mounted() {
    setTimeout(async () => {
      const stripePromise = loadStripe(this.stripePublicKey);
      this.stripe = await stripePromise;
      const elements = this.stripe.elements();

      this.cardNumber = elements.create('cardNumber', {
        classes: {
          base: 'form_global_wrap',
          empty: 'form-control',
          focus: 'form-control',
          invalid: 'form-control text-danger',
          complete: 'form-control',
        },
      })
      const cardExpiry = elements.create('cardExpiry', {
        classes: {
          base: 'form_global_wrap',
          empty: 'form-control',
          focus: 'form-control',
          invalid: 'form-control text-danger',
          complete: 'form-control',
        }
      });

      const cardCvc = elements.create('cardCvc', {
        classes: {
          base: 'form_global_wrap',
          empty: 'form-control',
          focus: 'form-control',
          invalid: 'form-control',
          complete: 'form-control',
        }
      });

      // Add an instance of the card Element into the `card-element` div

      this.cardNumber.mount('.form_inputx#card-number');
      cardExpiry.mount('.form_inputx#card-expiry');
      cardCvc.mount('.form_inputx#card-cvc');
    }, 1000)
  },
  methods: {
    validateInput(field, event) {
      let value = event.target.value.replace(/\D/g, '');
      
      if (field === 'card_number' && value.length > 16) {
        value = value.substring(0, 16);

        this.form[field] = value;
      } else if (field === 'card_expire_date') {
        let value = event.target.value.replace(/[^0-9/]/g, '');
        const previousValue = this.form.card_expire_date;

        if (value.length === 2 && previousValue.length === 3 && !event.inputType.includes('deleteContentBackward')) {
          value = value + '/';
        }

        // Limit input length to 5 (MM/YY format)
        if (value.length > 5) {
          value = value.substring(0, 5);
        }

        this.form[field] = value;
      } else {
        this.form[field] = value;
      }
    },
    getPaymentMethod() {
      this.axios.get(`/customer-payment-methods/${this.editId}`)
          .then(({data}) => {
            this.form = data.data
          })
    },
    async submit() {
      this.allErrors = null;

      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardNumber,
        billing_details: {
          name: this.name
        }
      });

      if (error) {
        this.error = error.message;
        this.processing = false;
      } else {
        let apiUrl
        this.form.stripe_payment_method_id = paymentMethod.id
        if (this.editId) {
          this.form._method = 'PUT'
          apiUrl = `/customer-payment-methods/${this.editId}`
        } else {
          apiUrl = `/customer-payment-methods`
        }

        this.lyLoading = true;

        this.axios.post(apiUrl, this.form)
            .then(({ data }) => {
              if (data.success) {
                this.loadData()
                this.showSuccessMsg(data.message);
                this.closeModal()
              } else {
                this.showFailMsg(data.message);
              }
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors
              this.showFailMsg(err.response.data.message);
            })
            .finally(() => {
              this.lyLoading = false;
            })
      }
    },
  }
}
</script>
<style scoped>

</style>
  